import React, { useState } from "react";
import pdlStyles from "../../PDL.module.css";
import StackedBarChart from "../../StackedBarChart/StackedBarChart";

const BUCKETS = [
  { key: "le1", label: "≤1 day", color: "#22c55e" },
  { key: "d2_5", label: "2–5 days", color: "#6b9ac4" },
  { key: "d6_15", label: "6–15 days", color: "#f2a71b" },
  { key: "d16_30", label: "16–30 days", color: "#f2790a" },
  { key: "d31_180", label: "31–180 days", color: "#e74c3c", warning: true },
  { key: "gt180", label: ">180 days", color: "#e83e8c", warning: true },
];

const DATA = {
  city: {
    Delhi: { le1: 1, d2_5: 1, d6_15: 1, d16_30: 1, d31_180: 1, gt180: 1 },
    Bangalore: { le1: 1, d2_5: 1, d6_15: 1, d16_30: 2, d31_180: 0, gt180: 0 },
    Mumbai: { le1: 0, d2_5: 1, d6_15: 0, d16_30: 1, d31_180: 0, gt180: 0 },
    Pune: { le1: 0, d2_5: 0, d6_15: 0, d16_30: 0, d31_180: 3, gt180: 0 },
    Chennai: { le1: 1, d2_5: 1, d6_15: 1, d16_30: 0, d31_180: 0, gt180: 2 },
  },

  depot: {
    Mayapuri: { le1: 1, d2_5: 0, d6_15: 1, d16_30: 0, d31_180: 1, gt180: 0 },
    Okhla: { le1: 0, d2_5: 1, d6_15: 0, d16_30: 1, d31_180: 0, gt180: 1 },
    Whitefield: { le1: 1, d2_5: 0, d6_15: 1, d16_30: 1, d31_180: 0, gt180: 0 },
    "Electronic City": { le1: 0, d2_5: 1, d6_15: 0, d16_30: 1, d31_180: 0, gt180: 0 },
    Andheri: { le1: 0, d2_5: 1, d6_15: 0, d16_30: 0, d31_180: 0, gt180: 0 },
    Chembur: { le1: 0, d2_5: 0, d6_15: 0, d16_30: 1, d31_180: 0, gt180: 0 },
    Hinjewadi: { le1: 0, d2_5: 0, d6_15: 0, d16_30: 0, d31_180: 1, gt180: 0 },
    Wagholi: { le1: 0, d2_5: 0, d6_15: 0, d16_30: 0, d31_180: 2, gt180: 0 },
    Guindy: { le1: 1, d2_5: 1, d6_15: 0, d16_30: 0, d31_180: 0, gt180: 1 },
    Ambattur: { le1: 0, d2_5: 0, d6_15: 1, d16_30: 0, d31_180: 0, gt180: 1 },
  },
};

export default function AgeingDistribution() {
  const [view, setView] = useState("city");

  return (
    <div className="container-fluid pt-2 mt-3">
      <div className="card border-0 shadow-sm rounded-1 overflow-hidden p-4">

        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
          <div className={pdlStyles.titleWrap}>
            <span className={pdlStyles.titleBar} />
            <span className={pdlStyles.title}>
              Ageing distribution
            </span>
            <span className={pdlStyles.subtitle}>
              Lost PDL — concentration by ageing bucket
            </span>
          </div>

          <div className="d-flex bg-light rounded-2 p-1">
            {["city", "depot"].map((type) => (
              <button
                key={type}
                type="button"
                className={`btn btn-sm border-0 px-3 ${
                  view === type
                    ? "text-white"
                    : "text-secondary bg-transparent"
                }`}
                style={
                  view === type
                    ? { backgroundColor: "#2b6f7e" }
                    : undefined
                }
                onClick={() => setView(type)}
              >
                By {type.charAt(0).toUpperCase() + type.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <StackedBarChart
          data={DATA[view]}
          buckets={BUCKETS}
        />

      </div>
    </div>
  );
}